import { render, staticRenderFns } from "./MPagination.vue?vue&type=template&id=53429242&scoped=true"
import script from "./MPagination.vue?vue&type=script&lang=js"
export * from "./MPagination.vue?vue&type=script&lang=js"
import style0 from "./MPagination.vue?vue&type=style&index=0&id=53429242&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53429242",
  null
  
)

export default component.exports